<template>
  <div class="personal-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <div class="left-nav">
        <sidebar-two
        :defaultActive="defaultActive"
        :title="sidebarTwoTitle"
        :list="sidebarTwoList"
        @selectMenu="selectMenu"></sidebar-two>
      </div>
      <div class="right-middle">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>图书</el-breadcrumb-item>
          <el-breadcrumb-item>分类</el-breadcrumb-item>
          <el-breadcrumb-item>{{breadcrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <div class="search-criteria">
          <ul>
            <li v-for="(item,index) in searchCriteria" :key="index">
              <div class="left-title">{{item.text}}</div>
              <ul class="right-val">
                <li v-for="(cItem,i) in item.list" :key="i">
                  <span @click="switchSpan(index, i)" :class="cItem.isActive ? 'spanActive' : ''">{{cItem.val}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div> -->
        <div class="filter-div">
          <ol>
            <li v-for="(item,index) in filterList" :key="index" :class="item.id === filterListActive ? 'isClickActive' : ''" @click="clickFilter(item.id, index)">
              {{item.text}}
              <img v-if="index > 0 && index < 4" :src="item.id === filterListActive ? jiantou1 : jiantou2" alt="">
              <img v-if="index === 4" :src="item.id === filterListActive ? jiage1 : jiage2" alt="">
            </li>
          </ol>
          <div class="num-d">
            共
            <span>{{total}}+</span>
            商品
          </div>
        </div>
        <div class="data-view">
          <ul>
            <li v-for="(item,index) in dataList" :key="index">
              <div class="img-d" @click="goDetails(item.id)">
                <img :src="item.imgUrl" alt="">
              </div>
              <div class="content-d">
                <!-- <p class="p-name">{{item.name}}</p> -->
                <div class="p-name" v-html="item.name"></div>
                <p class="p-money">
                  ￥{{item.money ? item.money : item.price}}
                  <span v-show="item.money">
                    定价：￥{{item.price}}
                  </span>
                </p>
                <p class="p-eBookPrice">
                  <span v-show="item.eBookPrice">
                    电子书:￥
                    {{item.paperPromotionPrice ? item.paperPromotionPrice : item.eBookPrice}}
                    <span style="text-decoration: line-through" v-show="item.paperPromotionPrice">
                      定价：{{item.eBookPrice}}
                    </span>
                  </span>
                  </p>
                <el-rate
                  class="star"
                  v-model="item.star"
                  disabled
                  show-score
                  text-color="red"
                  score-template="{value}颗星">
                </el-rate>
                <div class="d-describe" v-html="item.describe"></div>
                <p class="p-btns">
                  <button @click="trialReading(item)">在线试读</button>
                  <img
                    @click="shoppingCart(item)"
                    :src="item.isGwc ? gwc2 : gwc1"
                    alt=""
                    :class="item.isGwc ? 'imgActive' : ''">
                  <img @click="collection(item)" :src="item.isSc ? star2 : star1" alt="">
                </p>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo
  },
  data () {
    return {
      pageSize: 10,
      total: 0,
      currentPage: 1,
      sidebarTwoTitle: '个人中心',
      breadcrumb: '',
      defaultActive: '',
      jiantou1: require('@/assets/images/fl/jt1.png'),
      jiantou2: require('@/assets/images/fl/jt2.png'),
      jiage1: require('@/assets/images/fl/jg1.png'),
      jiage2: require('@/assets/images/fl/jg2.png'),
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      sidebarTwoList: [],
      searchObj: {
        filterId: '2',
        catId: ''
      },
      searchCriteria: [{
        text: '价格',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '0-9',
          isActive: false
        }, {
          val: '9-19',
          isActive: false
        }, {
          val: '19-29',
          isActive: false
        }, {
          val: '29-39',
          isActive: false
        }, {
          val: '39以上',
          isActive: false
        }]
      }, {
        text: '客户评价',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '5星',
          isActive: false
        }, {
          val: '4星以上',
          isActive: false
        }, {
          val: '3星以上',
          isActive: false
        }, {
          val: '2星以上',
          isActive: false
        }, {
          val: '1星以上',
          isActive: false
        }]
      }, {
        text: '上线时间',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '2018',
          isActive: false
        }, {
          val: '2017',
          isActive: false
        }, {
          val: '2016',
          isActive: false
        }, {
          val: '2015',
          isActive: false
        }, {
          val: '2014以前',
          isActive: false
        }]
      }],
      filterListActive: '2',
      filterList: [{
        id: '2',
        text: '综合',
        isTrue: true
      },
      // {
      //   id: '2',
      //   text: '销量',
      //   isTrue: false
      // },
      {
        id: '3',
        text: '评价',
        isTrue: false
      }, {
        id: '1',
        text: '出版时间',
        isTrue: false
      }, {
        id: '4',
        text: '价格',
        isTrue: false
      }],
      dataList: []
    }
  },
  methods: {
    selectMenu (obj) { // 左边菜单选择
      this.breadcrumb = obj.text
      this.searchObj.catId = obj.id
      this.getCategoryBooks(0, this.searchObj)
    },
    switchSpan (index, cindex) {
      let list = this.searchCriteria[index].list
      list.forEach((e, i) => {
        e.isActive = i === cindex
      })
    },
    clickFilter (id, index) { // 切换排序
      this.filterListActive = id
      this.searchObj.filterId = id
      this.getCategoryBooks(0, this.searchObj)
    },
    trialReading (item) { // 在线试读
      if (item.eBookPrice) {
        let routeData = this.$router.resolve({
          name: 'Book',
          query: {
            bookId: item.id,
            type: 1
          }
        })
        window.open(routeData.href, '_blank')
        // window.open('http://localhost:8080/#/book?bookId=' + `${item.id}&type=1`)
      } else {
        alert('该书籍没有电子书')
      }
    },
    shoppingCart (item) { // 购物车
      const state = item.isGwc
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isGwc = true
              this.$root.eventHub.$emit('update_shoppingNum')
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              } else {
                this.$root.eventHub.$emit('update_shoppingNum')
              }
            })
          }
        }
      }
    },
    collection (item) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!item.isSc) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}`
          this.$get(this.$allUrl.addFavorite + par).then(res => {
            if (res.code === '0') {
              this.$notify({
                title: '成功',
                message: '已成功收藏',
                type: 'success',
                showClose: false,
                duration: 1500
              })
              item.isSc = true
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    },
    handleCurrentChange (val) { // 分页
      const start = (val - 1) * this.pageSize
      this.getCategoryBooks(start, this.searchObj)
    },
    getCatagory () { // 获取图书分类
      const catId = this.$route.params.catId
      this.$get(this.$allUrl.getCatagory).then(res => {
        if (res.code === '0') {
          const list = res.data
          list.forEach(element => {
            this.sidebarTwoList.push({
              id: element.catId,
              text: element.catName
            })
          })
          if (catId) {
            this.defaultActive = catId.toString()
            this.searchObj.catId = catId
            this.breadcrumb = this.$route.params.text
          } else {
            this.breadcrumb = this.sidebarTwoList[0].text
            this.searchObj.catId = this.sidebarTwoList[0].id
            this.defaultActive = (this.sidebarTwoList[0].id).toString()
          }
          this.getCategoryBooks(0, this.searchObj)
        }
      })
    },
    getCategoryBooks (start, obj) { // 获取分类数据
      const num = this.pageSize
      const categoryId = obj.catId
      const type = obj.filterId
      const userId = this.$store.state.userMsg.id
      const par = userId ? `?num=${num}&start=${start}&categoryId=${categoryId}&type=${type}&userId=${userId}` : `?num=${num}&start=${start}&categoryId=${categoryId}&type=${type}`
      const self = this
      this.$get(this.$allUrl.getCategoryBooks + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          self.dataList = []
          self.total = res.recordsTotal
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            self.dataList.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              money: e.promotionPrice,
              price: e.paperPrice,
              eBookPrice: e.emark === 0 ? '' : e.bookPrice,
              author: e.bookAuthors,
              star: e.starLevel,
              describe: e.bookSummary,
              isGwc: false,
              isSc: e.favorite !== null,
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    },
    goDetails (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    this.getCatagory()
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        // margin-left: 20px;
        padding-left: 15px;
        .search-criteria{
          background: #EDEDEE;
          ul{
            list-style: none;
            padding: 0 10px;
            margin: 0;
            margin-top: 10px;
            font-size: 14px;
            border: 1px solid #dddddd;
            li:last-child{
              border: 0;
            }
            li{
              display: flex;
              line-height: 30px;
              border-bottom: 1px dashed #d2c7c7;
              .left-title{
                width: 80px;
                color: #666666;
              }
              .right-val{
                display: flex;
                border: 0;
                margin: 0;
                li{
                  width: 80px;
                  color: #999999;
                  border: 0;
                  span{
                    cursor: pointer;
                  }
                  .spanActive{
                    color: #990000;
                  }
                }
              }
            }
          }
        }
        .filter-div{
          background: #EDEDEE;
          height: 30px;
          margin-top: 20px;
          border: 1px solid #dddddd;
          display: flex;
          font-size: 14px;
          ol{
            list-style: none;
            display: flex;
            padding: 0;
            margin: 4px 10px;
            height: 20px;
            border: 1px solid #dddddd;
            li:last-child{
              border: 0;
            }
            li{
              background-color: white;
              padding: 0 10px;
              border-right: 1px solid #dddddd;
              cursor: pointer;
            }
            .isClickActive{
              color: white;
              background-color: #7D74A0;
            }
          }
          .num-d{
            flex: 1;
            text-align: right;
            line-height: 30px;
            margin-right: 10px;
            color: #a1a1a1;
            span{
              color: #666666;
              font-weight: 600;
            }
          }
        }
        .data-view{
          ul{
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-wrap: wrap;
            li{
              flex: 1;
              max-width: 50%;
              min-width: 50%;
              display: flex;
              padding: 20px 0;
              border-bottom: 1px solid #DDDDDD;
              .img-d{
                font-size: 0;
                img{
                  width: 137px;
                  height: 196px;
                  display: block;
                }
              }
              .content-d{
                padding-left: 15px;
                flex: 1;
                font-size: 14px;
                overflow: hidden;
                padding-right: 15px;
                p{
                  padding: 10px 0 0 0;
                  margin: 0;
                }
                .p-name{
                  color: #35353b;
                  font-size: 16px;
                  padding-top: 0;
                  overflow: hidden;
                  word-break: break-all;
                  display: -moz-box;
                  -moz-box-orient:vertical;
                  display: -webkit-box;
                  -webkit-box-orient:vertical;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 1;
                }
                .p-money{
                  color: #de0024;
                  font-weight: 600;
                  font-size: 16px;
                  span{
                    font-weight: 200;
                    text-decoration: line-through;
                    color: #A2A2A2;
                    font-size: 14px;
                  }
                }
                .p-eBookPrice{
                  color: #A2A2A2;
                  height: 19px;
                }
                .star{
                  margin-top: 10px;
                }
                .d-describe{
                  margin-top: 10px;
                  height: 37px;
                  overflow: hidden;
                  word-break: break-all;
                  display: -moz-box;
                  -moz-box-orient:vertical;
                  display: -webkit-box;
                  -webkit-box-orient:vertical;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                }
                .p-btns{
                  vertical-align: middle;
                  button{
                    width: 100px;
                    height: 28px;
                    background-color: #B7151E;
                    color: white;
                    outline: none;
                    border: 0;
                    border-radius: 6px;
                    cursor: pointer;
                    float: left;
                  }
                  img{
                    padding: 0 10px;
                    cursor: pointer;
                  }
                  .imgActive{
                    cursor: auto;
                  }
                }
              }
            }
          }
          .pagination{
            text-align: right;
            padding: 50px 0;
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Classification/classification.vue


// WEBPACK FOOTER //
// src/components/Classification/classification.vue